export const TASK_PHASE_ORDER = [
  "Account & access",
  "Banking & cards",
  "Company data",
  "Accounting setup",
  "Spend & budget rules",
  "Final sync",
];
